export default __webpack_public_path__ + "static/media/bg-singin.8f54ceac.jpg";